import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['group_id', 'Int!'],
  ['member', 'InputMemberId'],
]);
export default function REMOVE_GROUP_MEMBER() {
  return gql`
    mutation RemoveGroupMember(${parametersTypeString}) {
      removeGroupMember(${parametersAssignString}) {
        ${defaultResponse}
      }
    }
  `;
}
